export const groupStyles = {
  root: {
    minHeight: "40px",
    maxHeight: "470px",
    overflowY: "auto",
    padding: "15px",
  },
  buttonGrid: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
  },
  girdClass: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  selectClass: {
    height: "40px",
  },
  labelClass: {
    backgroundColor: "#FFFFFF",
  },
};
